'use strict';

module.exports = require('./src/js/adaptor/jquery');



//////////////////
// WEBPACK FOOTER
// ./~/perfect-scrollbar/jquery.js
// module id = 122
// module chunks = 25